/**税款缴纳 */
import { $http, buildHeaders } from "./index";

//获取税款缴纳列表
export const taxpay_list = (params) => {
  return $http.get("/admin/TaxPay/index", { params });
};

//立即缴款
export const taxpay_pay = (data) => {
  return $http.post("/admin/TaxPay/doPayTax", data, {
    headers: buildHeaders(3),
  });
};

//获取税款缴纳及三方协议列表
export const taxpay_gettripleagreement = (id) => {
  return $http.get("/admin/TaxPay/getTripleAgreement", {
    params: { id },
  });
};

//从税局获取欠费信息
export const taxpay_pull = (data) => {
  return $http.post("/admin/TaxPay/pullArrearage", data, {
    headers: buildHeaders(3),
  });
};

//更新缴款结果
export const taxpay_update = (data) => {
  return $http.post(
    "/admin/TaxPay/getPayTaxResult",
    { id: data },
    {
      headers: buildHeaders(3),
    }
  );
};

//作废电子票号
export const taxpay_cancel = (data) => {
  return $http.post(
    "/admin/TaxPay/cancelTaxReceiptNumber",
    { id: data },
    {
      headers: buildHeaders(3),
    }
  );
};

//导出
export const taxpay_export = (params) => {
  return $http.get("/admin/TaxPay/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//操作记录
export const taxpay_log = (params) => {
  return $http.get("/admin/TaxPay/log", { params });
};

//开具完税证明
export const taxpay_addvoucherlog = (data) => {
  return $http.post("/admin/TaxPay/addVoucherLog", data, {
    headers: buildHeaders(3),
  });
};

//完税证明操作记录
export const taxpay_getvoucherlog = (params) => {
  return $http.get("/admin/TaxPay/getVoucherLog", { params });
};

//下载发薪单电子回单
export const taxpay_log_donwload = (params) => {
  return $http.get("/admin/TaxPay/downloadVoucher", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};
